import React from 'react';
import { Gift, Star, Clock, CheckCircle } from 'lucide-react';
import idly from "../assets/idly.jpg";
import  Coffee  from "../assets/coffee.jpg";
import  halwaa from "../assets/halwaa.jpg";
import masaladosa from "../assets/masaladosa.jpg";
export const RewardsPage = () => {
  const availableRewards = [
    {
      id: 1,
      title: 'Free Idly ',
      description: 'Get a free Idly  on your next order',
      coins: 100,
      image: idly,
      available: false
    },
    {
      id: 2,
      title: '20% Off Next Order',
      description: 'Save 20% on your next purchase',
      coins: 50,
      image: masaladosa,
      available: false
    },
    {
      id: 3,
      title: 'Free Dessert',
      description: 'Complimentary dessert with any main course',
      coins: 75,
      image: halwaa,
      available: false
    },
    {
      id: 4,
      title: 'Free coffee',
      description: 'Get a free coffee  on your next order',
      coins: 200,
      image: Coffee,
      available: false
    }
  ];

  const rewardHistory = [
    // {
    //   id: 1,
    //   title: 'Free Appetizer',
    //   redeemedDate: '2024-01-15',
    //   coins: 30,
    //   status: 'used'
    // },
    // {
    //   id: 2,
    //   title: '10% Off Order',
    //   redeemedDate: '2024-01-10',
    //   coins: 25,
    //   status: 'used'
    // }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Rewards Center</h1>
        <p className="text-gray-600">Redeem your Aaladipattiyan Coins for exclusive rewards</p>
      </div>

      {/* Coin Balance */}
      <div className="  bg-gradient-to-r from-yellow-500 to-orange-500 rounded-2xl p-6 mb-8 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold mb-2">Your Coin Balance</h2>
            <p className="text-green-100">Available to spend</p>
          </div>
          <div className="text-right">
            <div className="text-4xl font-bold">0</div>
            <div className="text-green-100">Aaladipattiyan Coins</div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Available Rewards */}
        <div className="lg:col-span-2">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Available Rewards</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {availableRewards.map((reward) => (
              <div
                key={reward.id}
                className={`bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-200 hover:shadow-xl ${
                  !reward.available ? 'opacity-60' : ''
                }`}
              >
                <img
                  src={reward.image}
                  alt={reward.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-xl font-bold text-gray-800">{reward.title}</h3>
                    <div className="flex items-center gap-1 bg-yellow-100 px-2 py-1 rounded-full">
                      <Star size={14} className="text-yellow-600" />
                      <span className="text-sm font-semibold text-yellow-600">{reward.coins}</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4">{reward.description}</p>
                  <button
                    disabled={!reward.available}
                    className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors ${
                      reward.available
                        ? 'bg-gradient-to-r from-yellow-500 to-orange-500'
                        : 'bg-gray-200 text-gray-500 cursor-not-allowed'
                    }`}
                  >
                    {reward.available ? 'Redeem Now' : 'Not Enough Coins'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reward History */}
        <div className="lg:col-span-1">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Recent Activity</h2>
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="space-y-4">
              {rewardHistory.map((item) => (
                <div key={item.id} className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <CheckCircle size={20} className="text-green-600" />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-gray-800">{item.title}</h4>
                    <p className="text-sm text-gray-600">Redeemed on {item.redeemedDate}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-semibold text-gray-800">-{item.coins}</div>
                    <div className="text-xs text-gray-500">coins</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <Clock size={16} className="text-blue-600" />
                <span className="text-sm font-semibold text-blue-800">Upcoming Expiry</span>
              </div>
              <p className="text-sm text-blue-700">
                0 coins will expire in coming 30 days
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};